import { render, staticRenderFns } from "./FieldBooleanSwitch.vue?vue&type=template&id=185956b4&scoped=true&"
import script from "./FieldBooleanSwitch.vue?vue&type=script&lang=js&"
export * from "./FieldBooleanSwitch.vue?vue&type=script&lang=js&"
import style0 from "./FieldBooleanSwitch.vue?vue&type=style&index=0&id=185956b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185956b4",
  null
  
)

export default component.exports